import { render, staticRenderFns } from "./AddIpAddress.vue?vue&type=template&id=fb2b3fe2&scoped=true"
import script from "./AddIpAddress.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddIpAddress.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AddIpAddress.vue?vue&type=style&index=0&id=fb2b3fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2b3fe2",
  null
  
)

export default component.exports